/* eslint-disable jsx-a11y/anchor-is-valid */
import { FormGroup, Col, ControlLabel, Form, DropdownButton, MenuItem } from 'react-bootstrap';
import { AppointmentNotFound } from '../results/appointmentNotFound';

export class AffiliateAndSpecialtySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.renderDropdownAffiliatesDesktop = this.renderDropdownAffiliatesDesktop.bind(this);
    this.renderDropdownAffiliatesMobile = this.renderDropdownAffiliatesMobile.bind(this);
    this.renderDropdownSpecialtiesMobile = this.renderDropdownSpecialtiesMobile.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
  }

  /**
   * Renderiza el dropdown de selección de afiliados para escritorio.
   * @returns {JSX.Element} Elemento JSX del dropdown de afiliados (desktop).
   */
  renderDropdownAffiliatesDesktop() {
    return (
      <div>
        {this.props.UserAfiliate.length === 1 && (
          <div className="text-left">
            {this.props.UserAfiliate.map((item, index) => {
              return <h4>{item.FullName}</h4>;
            })}
          </div>
        )}

        {this.props.UserAfiliate.length > 1 && (
          <DropdownButton
            dropup={false}
            className="dropdown-custom"
            bsStyle="inline mt-12"
            onSelect={(e) => {
              this.props.OnChangeAfiliate(e, this.props.UserAfiliate);
            }}
            title={
              !this.props.NoPlaceholderUser
                ? parseText('Form.Content.FirstPlaceHolder')
                : this.props.NamePlaceholderUser
            }
            id="first"
          >
            {this.props.UserAfiliate.map((item, index) => {
              return (
                <MenuItem
                  eventKey={{
                    posision: index,
                    userType: item.UserTypeId,
                    userId: item.UserId,
                    BirthDate: item.BirthDate,
                    FullNameDrop: item.FullName,
                  }}
                >
                  {item.FullName}
                </MenuItem>
              );
            })}
          </DropdownButton>
        )}
      </div>
    );
  }

  /**
   * Renderiza el dropdown de selección de afiliados para dispositivos móviles.
   * @returns {JSX.Element} Elemento JSX del dropdown de afiliados (mobile).
   */
  renderDropdownAffiliatesMobile() {
    return this.props.UserAfiliate.length > 0 ? (
      <div>
        {this.props.UserAfiliate.length === 1 ? (
          <div className="text-left">
            {this.props.UserAfiliate.map((item, index) => {
              return <h4>{item.FullName}</h4>;
            })}
          </div>
        ) : (
          <select
            className="select-custom"
            onChange={(e) => {
              this.props.OnChangeAfiliate(e, this.props.UserAfiliate);
            }}
          >
            <option value="" disabled selected>
              {parseText('Form.Content.FirstPlaceHolder')}
            </option>
            {this.props.UserAfiliate.map((item, index) => {
              return (
                <option data-UserType={item.UserTypeId} data-BirthDate={item.BirthDate} value={index}>
                  {item.FullName}
                </option>
              );
            })}
          </select>
        )}
      </div>
    ) : (
      <select disabled className="select-custom">
        <option value="" selected>
          {parseText('Form.Content.FirstPlaceHolder')}
        </option>
      </select>
    );
  }

  /**
   * Renderiza el dropdown de selección de especialidades para escritorio.
   * @returns {JSX.Element} Elemento JSX del dropdown de especialidades (desktop).
   */
  renderDropdownSpecialtiesDesktop() {
    return this.props.EspecialidadesActive.length > 0 ? (
      <DropdownButton
        className="dropdown-custom"
        bsStyle="inline mt-12"
        onSelect={this.props.OnChangeSpecialities}
        disabled={!this.props.EnabledDropdown}
        title={
          !this.props.NoPlaceholderSpec ? parseText('Form.Content.SecondPlaceHolder') : this.props.NamePlaceholderSpec
        }
        id="second"
      >       
        {this.props.EspecialidadesActive.map((item, index) => {
          return (
            <MenuItem
              eventKey={{
                Agrupador: item.Agrupador,
                PromotionAndPreventionInfo: item.PromotionAndPreventionInfo,
                Promotion: item.IsPromotionAndPrevention,
                Description:
                  item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.Description,
                ImageUrl: item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.ImageUrl,
                Name: item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.Name,
                value: item.ServiceCode,
                NameService: item.ServiceName,
              }}
            >
              {item.ServiceName}
            </MenuItem>
          );
        })}
      </DropdownButton>
    ) : (
      <DropdownButton
        className="dropdown-custom"
        bsStyle="inline mt-12"
        disabled={!this.props.EnabledDropdown}
        title={parseText('Form.Content.SecondPlaceHolder')}
        id="second"
      ></DropdownButton>
    );
  }

  /**
   * Renderiza el dropdown de selección de especialidades para dispositivos móviles.
   * @returns {JSX.Element} Elemento JSX del dropdown de especialidades (mobile).
   */
  renderDropdownSpecialtiesMobile() {
    return this.props.EspecialidadesActive.length > 0 ? (
      <select
        className="select-custom select-especielidades"
        onChange={this.props.OnChangeSpecialities}
        disabled={!this.props.EnabledDropdown}
      >
        <option value="default" disabled selected>
          {parseText('Form.Content.SecondPlaceHolder')}
        </option>       
        {this.props.EspecialidadesActive.map((item, index) => {
          return (
            <option
              data-PromotionAndPreventionInfo={item.PromotionAndPreventionInfo}
              data-Promotion={item.IsPromotionAndPrevention}
              data-Description={
                item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.Description
              }
              data-ImageUrl={item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.ImageUrl}
              data-Name={item.PromotionAndPreventionInfo === null ? '' : item.PromotionAndPreventionInfo.Name}
              value={item.ServiceCode}
            >
              {item.ServiceName}
            </option>
          );
        })}
      </select>
    ) : (
      <select disabled className="select-custom">
        <option value="" selected>
          {parseText('Form.Content.SecondPlaceHolder')}
        </option>
      </select>
    );
  }

  /**
   * Renderiza el formulario de selección de afiliado y especialidad.
   * @returns {JSX.Element} Elemento JSX del formulario de selección.
   */
  renderSelect() {
    return (
      <div>
        <Form horizontal>
          <FormGroup controlId="formControlsSelect">
            <Col componentClass={ControlLabel} xs={12} sm={12} md={4} lg={3}>
              <ControlLabel>{parseText('Form.Content.FirstDropDown')}</ControlLabel>
            </Col>
            <Col xs={11} sm={11} md={6} lg={4}>
              {window.innerWidth >= 770
                ? this.renderDropdownAffiliatesDesktop()
                : this.renderDropdownAffiliatesMobile()}
            </Col>
            <Col xs={11} sm={11} md={6} lg={4}></Col>
          </FormGroup>
          <Col xs={12} sm={12} md={12} lg={12}>
            {this.props.NoneValidation ? (
              <AppointmentNotFound
                NoLink="false"
                NotFoundIcon={this.props.IconPanel}
                NotFoundMessage={parseText('sharedResources.General.ErrorMessageModal')}
              />
            ) : null}
          </Col>
          <FormGroup controlId="formControlsSelect">
            <Col componentClass={ControlLabel} xs={12} sm={12} md={4} lg={3}>
              <ControlLabel>{parseText('Form.Content.SecondDropDown')}</ControlLabel>
            </Col>
            <Col xs={11} sm={11} md={6} lg={4}>
              {window.innerWidth >= 770
                ? this.renderDropdownSpecialtiesDesktop()
                : this.renderDropdownSpecialtiesMobile()}
            </Col>
            <Col xs={11} sm={11} md={6} lg={4}>
              {this.props.IsPromotionValidation && this.props.ValidationDataPromotion ? (
                <a className="iconPromotionBtn" onClick={this.props.OpenModalInformative}>
                  <i className="fa fa-exclamation-circle"></i>
                </a>
              ) : null}
            </Col>
            {this.props.specialityValueSelected === '890242' ? ( // Dermatologia
              <Col xs={12}>
                <div id="appointmentNotFound">
                  <div className="warning-blue">
                    <div className="col-sm-12 col-md-1 text-center">
                      <i className="fa fa-info-circle"></i>
                    </div>
                    <div className="col-sm-12 col-md-11">
                      <div className="topM">
                        Apreciado usuario, te informamos que las sedes disponibles para agendamiento de citas de la
                        especialidad seleccionada en la ciudad de Bogotá son: Calle 26, Centro Mayor, Calle 134, Calle
                        145, San Roque, Calle 127, Calle 95
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ) : this.props.specialityValueSelected === '890282' ? ( // Otorrinonaringologia
              <Col xs={12}>
                <div id="appointmentNotFound">
                  <div className="warning-blue">
                    <div className="col-sm-12 col-md-1 text-center">
                      <i className="fa fa-info-circle"></i>
                    </div>
                    <div className="col-sm-12 col-md-11">
                      <div className="topM">
                        Apreciado usuario, te informamos que las sedes disponibles para agendamiento de citas de la
                        especialidad seleccionada en la ciudad de Bogotá son: Calle 153, Centro Mayor, Carrera 69,
                        Kennedy II, Calle 145, San Roque, Calle 127, Calle 95
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ) : this.props.specialityValueSelected === '890294' ? ( // Urología
              <Col xs={12}>
                <div id="appointmentNotFound">
                  <div className="warning-blue">
                    <div className="col-sm-12 col-md-1 text-center">
                      <i className="fa fa-info-circle"></i>
                    </div>
                    <div className="col-sm-12 col-md-11">
                      <div className="topM">
                        Apreciado usuario, te informamos que las sedes disponibles para agendamiento de citas de la
                        especialidad seleccionada en la ciudad de Bogotá son: San Roque, Calle 134, Calle 153, Calle 42,
                        Calle 94, Centro Mayor, Calle 127, Calle 95, Kennedy II
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ) : null}
          </FormGroup>
        </Form>
      </div>
    );
  }

  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 box-background-gray" id="selectDropDownValidation">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-form-select-content">
          <h4>{parseText('Form.Content.TitleForm')}</h4>
          <hr />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-select-content">{this.renderSelect()}</div>
      </div>
    );
  }
}
